export const statusOptions = [
  {
    value: 'refund_request_created',
    label: 'Refund Request Created',
    bgc: '#d3d3d3'
  },
  { value: 'auth_access', label: 'Auth Access', bgc: '#FFB6C1' },
  { value: 'check_0', label: 'Check 0', bgc: '#a66cff' },
  { value: 'check_0_reject', label: 'Check 0 - Reject', bgc: 'red' },
  { value: 'facturacion', label: 'Facturacion', bgc: '#9034A7' },
  { value: 'cs_missing_docs', label: 'CS Missing Docs', bgc: '#de520d' },
  { value: 'lost', label: 'Lost', bgc: 'orange' },
  { value: 'quality_control', label: 'Quality Control', bgc: '#d3d3d3' },
  { value: 'check_2_pending', label: 'Check 2 - Pending', bgc: '#38a5f5' },
  { value: 'check_2_reject', label: 'Check 2 - Reject', bgc: '#d3d3d3' },
  {
    value: 'contabilidad_pending',
    label: 'Contabilidad - Pending',
    bgc: '#0056f6'
  },
  {
    value: 'approved_for_payment',
    label: 'Approved for Payment',
    bgc: '#3bbbd4'
  },
  {
    value: 'sent_to_payment',
    label: 'Submitted 4 Payment to PP',
    bgc: '#d3d3d3'
  },
  { value: 'paid', label: 'Paid', bgc: '#c7efcf' },
  { value: 'approved_by_sat', label: 'Approved by SAT', bgc: '#74cc4c' },

  { value: 'check_0_error', label: 'Check 0 - Error', bgc: '#d3d3d3' },
  { value: 'quarantine', label: 'Quarantine', bgc: '#d3d3d3' },
]

export const statusOptionsListView = [
  {
    value: 'Refund Request Created',
    label: 'Refund Request Created',
    bgc: '#d3d3d3'
  },
  { value: 'Auth Access', label: 'Auth Access', bgc: '#FFB6C1' },
  { value: 'Check 0', label: 'Check 0', bgc: '#a66cff' },
  { value: 'Check 0 - Reject', label: 'Check 0 - Reject', bgc: 'red' },
  { value: 'Facturacion', label: 'Facturacion', bgc: '#9034A7' },
  { value: 'CS Missing Docs', label: 'CS Missing Docs', bgc: '#de520d' },
  { value: 'Lost', label: 'Lost', bgc: 'orange' },
  { value: 'Quality Control', label: 'Quality Control', bgc: '#d3d3d3' },
  { value: 'Check 2 - Pending', label: 'Check 2 - Pending', bgc: '#38a5f5' },
  { value: 'Check 2 - Reject', label: 'Check 2 - Reject', bgc: '#d3d3d3' },
  {
    value: 'Contabilidad - Pending',
    label: 'Contabilidad - Pending',
    bgc: '#0056f6'
  },
  {
    value: 'Approved for Payment',
    label: 'Approved for Payment',
    bgc: '#3bbbd4'
  },
  {
    value: 'Submitted 4 Payment to PP',
    label: 'Submitted 4 Payment to PP',
    bgc: '#d3d3d3'
  },
  { value: 'Paid', label: 'Paid', bgc: '#c7efcf' },
  { value: 'Approved by SAT', label: 'Approved by SAT', bgc: '#74cc4c' },
  { value: 'Check 0 - Error', label: 'Check 0 - Error', bgc: '#d3d3d3' },
  { value: 'Quarantine', label: 'Quarantine', bgc: '#d3d3d3' },
  { value: 'Batched Consolidated File', label: 'Batched Consolidated File', bgc: '#d3d3d3' },
]

export const proccessingStatusOptions = [
  {
    value: 'new_pending',
    label: 'New / Pending',
    bgc: '#d3d3d3'
  },
  { value: 'documents_uploaded', label: 'Documents Uploaded', bgc: '#a66cff' },
  {
    value: 'documents_classified',
    label: 'Documents Classified',
    bgc: '#f6dc00'
  },
  {
    value: 'documents_classification_failed',
    label: 'Documents Classification Failed',
    bgc: '#de520d'
  },
  {
    value: 'classification_passed',
    label: 'Classification Passed',
    bgc: '#38a5f5'
  },
  {
    value: 'classification_failed',
    label: 'Classification Failed',
    bgc: '#d3d3d3'
  },
  {
    value: 'classification_manually_completed',
    label: 'Classification Manually Completed',
    bgc: '#0056f6'
  },
  {
    value: 'ocr_completed',
    label: 'OCR Completed',
    bgc: '#3bbbd4'
  },
  {
    value: 'ocr_failed',
    label: 'OCR Failed',
    bgc: '#d3d3d3'
  },
  {
    value: 'ocr_check_passed',
    label: 'OCR Check Passed',
    bgc: '#0056f6'
  },
  {
    value: 'ocr_check_failed',
    label: 'OCR Check Failed',
    bgc: '#3bbbd4'
  }
]

export const documentStatusOptions = [
  {
    value: 'missing_documents',
    label: 'Missing Docs',
    bgc: '#de520d'
  },
  { value: 'documents_uploaded', label: 'Docs Uploaded', bgc: '#d3d3d3' },

  {
    value: 'documents_classification_queue',
    label: 'Classification Queue',
    bgc: '#d3d3d3'
  },
  {
    value: 'documents_classified',
    label: 'Classification Complete',
    bgc: '#d3d3d3'
  },
  {
    value: 'documents_classification_failed',
    label: 'Classification Failed',
    bgc: '#de520d'
  },
  {
    value: 'classification_manually_completed',
    label: 'Manual Classification Completed',
    bgc: '#d3d3d3'
  },
  {
    value: 'manual_updates_required',
    label: 'Manual Updates Required',
    bgc: '#de520d'
  },
  {
    value: 'ocr_queue',
    label: 'OCR Queue',
    bgc: '#d3d3d3'
  },
  {
    value: 'ocr_failed',
    label: 'OCR Failed',
    bgc: '#d3d3d3'
  },
  {
    value: 'ocr_completed',
    label: 'OCR Complete',
    bgc: '#74cc4c'
  },
  {
    value: 'run_manual_ocr',
    label: 'Run Manual OCR',
    bgc: '#d3d3d3'
  },
  {
    value: 'validation_failed',
    label: 'Validation Failed',
    bgc: '#d3d3d3'
  },
  {
    value: 'ocr_check_failed',
    label: 'OCR Check Failed',
    bgc: '#d3d3d3'
  },
  {
    value: 'validated',
    label: 'Validated',
    bgc: '#d3d3d3'
  }
]